import helper from "./helper";
import tippy from "tippy.js";
import cash from "cash-dom";
import Toastify from "toastify-js";

(function () {
    if (cash("#ticket-input").length) {
        cash('#ticket-input')[0].addEventListener('input', function () {
            helper.postAjax('/plan/api/dispo/ticket', {
                id: parseInt(cash('#dispo-id')[0].innerText),
                tickets: this.value
            }, function (data) {
                data = JSON.parse(data);
                cash('#tickets')[0].innerText = data.ticket;
                update_progressbar(data.ticket)
            })
        })
    }

    function update_progressbar(total) {
        let max = parseFloat(cash('#tickets-max')[0].innerText);
        let width;
        let progressbarElement = cash('#progressbar')[0];

        if (total > max) {
            width = '100%';
        } else {
            width = ((100.0 / max) * total) + '%';
        }
        progressbarElement.style.width = width;
    }

    if (cash("#dispo_edit").length) {
        cash('.template__copy').each((index, ele) => {
            ele.addEventListener('click', function (event) {
                event.preventDefault();
                let target = ele.dataset.target;
                helper.postAjax('/api/dispo/info', {
                    id: parseInt(ele.dataset.id),
                    type: target
                }, function (data) {
                    data = JSON.parse(data);
                    if (data.reload) {
                        location.reload();
                    }
                    document.querySelector('#' + target).textContent = '';

                    setTimeout(() => {
                        document.querySelector('#' + target).textContent = data.content;
                        Toastify({
                            node: $("#success-notification-content").clone().removeClass("hidden")[0],
                            duration: 5000,
                            newWindow: true,
                            close: true,
                            gravity: "top",
                            position: "right",
                            stopOnFocus: true,
                        }).showToast();
                    }, 100)

                    tailwind.Dropdown.getInstance(document.querySelector('#dropdown_' + target)).hide();
                })
            })
        })
    }

    if (cash(".__copy").length) {
        cash('.__copy').each((index, ele) => {
            tippy(ele, {
                content: "Kopieren?",
            });
            tippy(ele, {
                content: "Kopiert!",
                trigger: 'click',
                animation: 'fade',
                onShown(instance) {
                    setTimeout(() => {
                        instance.hide();
                    }, 500);
                },
                duration: [null, 2000]
            });
            ele.addEventListener('click', async function (event) {
                let input_field = ele.previousElementSibling;
                try {
                    await copyToClipboard(input_field.value);
                    tippy(ele, {
                        content: "Kopiert!",
                        trigger: 'click',
                    })

                } catch (error) {
                    console.error(error);
                }
            })
        })
    }

    async function copyToClipboard(textToCopy) {
        // Navigator clipboard api needs a secure context (https)
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(textToCopy);
        } else {
            // Use the 'out of viewport hidden text area' trick
            const textArea = document.createElement("textarea");
            textArea.value = textToCopy;

            // Move textarea out of the viewport, so it's not visible
            textArea.style.position = "absolute";
            textArea.style.left = "-999999px";

            document.body.prepend(textArea);
            textArea.select();

            try {
                document.execCommand('copy');
            } catch (error) {
                console.error(error);
            } finally {
                textArea.remove();
            }
        }
    }

})();